import React from 'react';
import {Input} from 'antd';
import {IPropsElement} from "../../../pages/ChecklistPage/PopupEdit/constants";
import {callEventChecklist, getChecklist, useChecklist} from "../ChecklistContext";

const ShortTextElement: React.FC<IPropsElement> = (props) => {
    const {placeHolder} = props.properties;
    const {index} = props;
    const [value] = useChecklist(state => state.result[index]);
    const {onResultChange} = callEventChecklist();
    const {disabled} = getChecklist()();

    return <Input
        placeholder={placeHolder}
        disabled={disabled}
        value={value}
        onChange={({target}) => onResultChange({[index]: target.value})}
    />
};

export default ShortTextElement;
